"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewSubject = void 0;
var ReviewSubject;
(function (ReviewSubject) {
    ReviewSubject["AIContentStructure"] = "AIContentStructure";
    ReviewSubject["ContentImport"] = "ContentImport";
})(ReviewSubject || (exports.ReviewSubject = ReviewSubject = {}));
